import React from "react";
import classNames from "classnames";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { TransactionStatus as TransactionStatusValues } from "@common/types/transaction";
import { TRANSACTION_STATUS_LABELS } from "@common/constants";
import { TransactionListItem } from "@common/schemas/transaction.schema";
import { Tag } from "@design-system/Tag/Tag";
import { LockIcon } from "@icons";
import styles from "./TransactionStatus.module.scss";

interface Props {
    transaction: TransactionListItem;
    className?: string;
    isLocked?: boolean;
}

export const TransactionStatus: React.FC<Props> = ({
    transaction,
    className,
    isLocked = false,
}) => {
    const color =
        transaction.status === TransactionStatusValues.PENDING
            ? "neutral"
            : "error";

    const statusTag =
        transaction.status === TransactionStatusValues.COMPLETED ? null : (
            <Tag
                color={color}
                className={classNames(styles.transactionStatus, className)}
                data-testid="transaction-status"
            >
                {TRANSACTION_STATUS_LABELS[transaction.status]}
            </Tag>
        );

    const lockTag = isLocked ? (
        <Tag
            color="neutral"
            className={classNames(styles.transactionStatus, className)}
        >
            <Tooltip
                content={
                    <>
                        This transaction is locked.
                        <br />
                        To unlock, go to <strong>Settings &gt; Locks</strong>
                    </>
                }
            >
                <span className={styles.lockContainer}>
                    <span className={styles.lockIcon}>
                        <LockIcon className="icon-color-current mr-1" />
                    </span>
                    Locked
                </span>
            </Tooltip>
        </Tag>
    ) : null;

    return (
        <>
            {statusTag}
            {lockTag}
        </>
    );
};
